import { environment } from "../../../../../environments/environment";

export class ApiUrls {
  /**
   * Base URL
   */
  private static BASE_URL = environment.API_BASE_URL;

  /**
   * Endpoint Entities (shared parts of the URL)
   */
  public static readonly LOGIN = "login";

  public static readonly RESET_PASSWORD = "reset-password";

  public static readonly REGISTER = "register";

  public static readonly COMPLETE_PROFILE = "complete-profile";

  public static readonly LOGIN_WITH_GOOGLE = "login-google";

  public static readonly LOGIN_WITH_FACEBOOK = "login-fb";

  public static readonly LOGIN_WITH_APPLE = "login-apple";

  public static readonly USER = "user";
  public static readonly USER_CONFIGURATION = "user-configuration";
  public static readonly MATCH = "match";
  public static readonly SAMPLE_STATISTICS = "sample-statistics";
  public static readonly WALLET = "wallet";

  public static readonly VISIBLE_WALLET_ON_APP = "visible-wallet-on-app";

  public static readonly PAYMENT_INFO = "payment-info";

  public static readonly AGGREGATE_STATISTICS = "aggregate-statistics";
  public static readonly LIST_STATISTICS = "list-statistics";

  public static readonly PLAYER_IDENTIFICATION = "player-identification";
  public static readonly IDENTIFICATION_INFORMATION =
    "players-identification-information";

  public static readonly ON_BOARDING = "on-boarding";

  public static readonly TERMS_AND_CONDITIONS = "terms_and_conditions_url";

  public static readonly PRIVACY_POLICY = "privacy_policy_url";

  public static readonly REGISTER_PUSH_PLAYER_ID = "register-push";

  public static readonly PLAYER_ALREADY_IDENTIFIED =
    "player-already-identified";

  public static readonly CREATE_MATCH_REQUEST = "create-match-request";

  public static readonly GET_CLUBS_LIST = "clubs";
  public static readonly GET_COURTS_LIST = "courts";

  public static readonly GET_BOOKINGS = "match-request";

  public static readonly HELP_MESSAGE = "help-message";

  public static readonly GET_CONTACT_WHATSAPP_NUMBER =
    "get-contact-whatsapp-number";

  public static readonly MINIMUM_APP_VERSION = "minimum-app-version";

  public static readonly CONTACT_TRAINER = "contact-trainer";
  public static readonly SHARE_SHORT_VIDEO = "share-short-video";
  public static readonly SHARE_EXTENDED_VIDEO = "share-extended-video";

  public static readonly APPLY_BOOKING_PAYMENT = "payment_type";
  public static readonly APPLY_COUPON = "apply_coupon";

  public static readonly UNAPPLY_COUPON = "unapply_coupon";

  public static readonly UPDATE_CONSENT = "consent";

  public static readonly CONFIRM_PAYMENT_DONE = "paycomet_transaction/done";

  public static readonly JOIN_BOOKING_SPLIT_PAID = "join-booking-split-paid";

  public static readonly NOTIFICATION = "notification";

  public static readonly LIST = "list";

  public static readonly COUNT = "count";

  public static readonly READ = "read";

  public static readonly DELETE = "delete";

  public static readonly GET_MARKETING_MESSAGE = "get-marketing-message";

  public static readonly SEARCH_MATCH_PLAYER = "search-user";

  public static readonly JOIN_MATCH = "join-match";

  public static readonly GET_RECENT_DATA = "recent-data";

  public static readonly MATCH_SHARE_STATISTICS = "share-statistics";

  public static readonly MATCH_SHARED_STATISTICS = "shared-statistics";

  public static readonly SET_COMPETITIVE_MATCH =
    "playerlevel/competitive-marker";

  public static readonly SET_COMPETITIVE_BOOKING =
    "playerlevel/competitive-marker-match-request";

  public static readonly INTERNAL_API = "internal_api";
  public static readonly GET_USER_TOKEN = "user-token";

  /**
   *  ENDPOINTS
   */

  /* Booking */
  public static readonly APPLY_BOOKING_PAYMENT_ENDPOINT = (bookingId: string) =>
    `${this.makeUrl(this.GET_BOOKINGS)}${bookingId}/${this.APPLY_BOOKING_PAYMENT}/`;

  public static readonly APPLY_COUPON_ENDPOINT = (bookingId: string) =>
    `${this.makeUrl(this.GET_BOOKINGS)}${bookingId}/${this.APPLY_COUPON}/`;

  public static readonly CONFIRM_PAYMENT_DONE_ENDPOINT = (orderId: string) =>
    `${this.makeUrl(this.CONFIRM_PAYMENT_DONE)}${orderId}`;

  public static readonly CREATE_MATCH_REQUEST_ENDPOINT = () =>
    `${this.makeUrl(this.CREATE_MATCH_REQUEST)}`;

  public static readonly DELETE_BOOKING_ENDPOINT = (bookingId: string) =>
    `${this.makeUrl(this.GET_BOOKINGS)}${bookingId}/delete/`;

  public static readonly EDIT_BOOKING_ENDPOINT = (bookingId: string) =>
    `${this.makeUrl(this.GET_BOOKINGS)}${bookingId}/edit/`;

  public static readonly GET_BOOKING_ENDPOINT = (bookingId: string) =>
    `${this.makeUrl(this.GET_BOOKINGS)}${bookingId}`;

  public static readonly GET_BOOKINGS_ENDPOINT = () =>
    `${this.makeUrl(this.GET_BOOKINGS)}`;

  public static readonly JOIN_BOOKING_SPLIT_PAID_ENDPOINT = (
    bookingId: string
  ) =>
    `${this.makeUrl(this.GET_BOOKINGS)}${bookingId}/${this.JOIN_BOOKING_SPLIT_PAID}/`;

  public static readonly UNAPPLY_COUPON_ENDPOINT = (bookingId: string) =>
    `${this.makeUrl(this.GET_BOOKINGS)}${bookingId}/${this.UNAPPLY_COUPON}/`;

  public static readonly UPDATE_CONSENT_ENDPOINT = (bookingId: string) =>
    `${this.makeUrl(this.GET_BOOKINGS)}${bookingId}/${this.UPDATE_CONSENT}`;

  /* Clubs */
  public static readonly GET_CLUBS_LIST_ENDPOINT = () =>
    `${ApiUrls.makeUrl(ApiUrls.GET_CLUBS_LIST)}`;
  /* Coach */
  public static readonly GET_COACH_PHONE_NUMBER_ENDPOINT = () =>
    `${ApiUrls.makeUrl(ApiUrls.CONTACT_TRAINER)}`;
  /* Contact */
  public static readonly GET_CONTACT_WHATSAPP_NUMBER_ENDPOINT = () =>
    `${ApiUrls.makeUrl(ApiUrls.GET_CONTACT_WHATSAPP_NUMBER)}`;

  public static readonly HELP_MESSAGE_ENDPOINT = () =>
    `${ApiUrls.makeUrl(ApiUrls.HELP_MESSAGE)}`;

  /* Courts */
  public static readonly GET_COURTS_LIST_ENDPOINT = (clubId: string) =>
    `${ApiUrls.makeUrl(ApiUrls.GET_COURTS_LIST)}${clubId}`;

  /* Marketing */
  public static readonly GET_MARKETING_MESSAGE_ENDPOINT = () =>
    `${ApiUrls.makeUrl(ApiUrls.GET_MARKETING_MESSAGE)}`;

  /* Match */
  public static readonly GET_PUBLIC_VIDEO_ENDPOINT = (
    matchId: string,
    video_type: string
  ) => `${ApiUrls.makeUrl(ApiUrls.MATCH)}${matchId}/${video_type}/`;

  public static readonly ADD_PLAYER_TO_MATCH_ENDPOINT = (matchId: string) =>
    `${ApiUrls.makeUrl(ApiUrls.MATCH)}${matchId}/edit/`;

  public static readonly MATCH_DETAIL_ENDPOINT = (matchId: string) =>
    `${ApiUrls.makeUrl(ApiUrls.MATCH)}${matchId}/`;

  public static readonly MATCH_COMPARE_ENDPOINT = (matchId: string) =>
    `${ApiUrls.makeUrl(ApiUrls.MATCH)}${matchId}/comparison/`;

  public static readonly JOIN_MATCH_ENDPOINT = (matchId: string) =>
    `${ApiUrls.makeUrl(ApiUrls.MATCH)}${matchId}/${ApiUrls.JOIN_MATCH}/`;

  public static readonly PAYMENT_INFO_ENDPOINT = (matchId: string) =>
    `${ApiUrls.makeUrl(ApiUrls.MATCH)}${matchId}/${ApiUrls.PAYMENT_INFO}`;

  public static readonly GET_MATCHES_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.MATCH);

  public static readonly PLAYER_ALREADY_SELECTED_ENDPOINT = (matchId: string) =>
    `${ApiUrls.makeUrl(ApiUrls.PLAYER_ALREADY_IDENTIFIED)}${matchId}/`;

  public static readonly GET_PLAYER_IDENTIFICATION_INFORMATION_ENDPOINT = (
    match_code: string
  ) => `${ApiUrls.makeUrl(ApiUrls.IDENTIFICATION_INFORMATION)}${match_code}`;

  public static readonly IDENTIFY_PLAYER_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.PLAYER_IDENTIFICATION);

  public static readonly MATCH_SHARE_STATISTICS_ENDPOINT = (matchId: string) =>
    `${ApiUrls.makeUrl(ApiUrls.MATCH)}${matchId}/${ApiUrls.MATCH_SHARE_STATISTICS}/`;

  public static readonly MATCH_SHARED_STATISTICS_ENDPOINT = (
    playerId: string
  ) => `${ApiUrls.makeUrl(ApiUrls.MATCH_SHARED_STATISTICS)}${playerId}/`;

  public static readonly LEAVE_MATCH_ENDPOINT = (matchId: string) =>
    `${this.makeUrl(this.MATCH)}${matchId}/leave/`;

  /* Notifications */
  public static readonly DELETE_NOTIFICATION_ENDPOINT = (id: number) =>
    `${ApiUrls.makeUrl(ApiUrls.NOTIFICATION)}${id}/${ApiUrls.DELETE}/`;

  public static readonly GET_NOTIIFCATIONS_ENDPOINT = () =>
    `${ApiUrls.makeUrl(ApiUrls.NOTIFICATION)}${ApiUrls.LIST}/`;

  public static readonly GET_UNREAD_NOTIFCATIONS_ENDPOINT = () =>
    `${ApiUrls.makeUrl(ApiUrls.NOTIFICATION)}${ApiUrls.COUNT}/`;

  public static readonly READ_NOTIFICATION_ENDPOINT = (id: number) =>
    `${ApiUrls.makeUrl(ApiUrls.NOTIFICATION)}${id}/${ApiUrls.READ}/`;

  public static readonly SEND_PUSH_PLAYER_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.REGISTER_PUSH_PLAYER_ID);

  /* Wallet */
  public static readonly GET_WALLET_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.WALLET);

  public static readonly VISIBLE_WALLET_ON_APP_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.VISIBLE_WALLET_ON_APP);

  public static readonly APPLY_WALLET_RECHARGE_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.WALLET);

  /* Homepage */
  public static readonly GET_RECENT_DATA_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.GET_RECENT_DATA);

  /* Onboarding */
  public static readonly ONBOARDING_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.ON_BOARDING);

  /* Statistics */
  public static readonly AGGREGATE_STATISTICS_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.AGGREGATE_STATISTICS);

  public static readonly SAMPLE_STATISTICS_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.SAMPLE_STATISTICS);

  public static readonly LIST_STATISTICS_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.LIST_STATISTICS);

  /* URLs */
  public static readonly GET_PRIVACY_POLICY_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.PRIVACY_POLICY);

  public static readonly GET_TERMS_AND_CONDITIONS_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.TERMS_AND_CONDITIONS);

  /* User */
  public static readonly COMPLETE_PROFILE_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.COMPLETE_PROFILE);

  public static readonly DELETE_USER_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.USER);

  public static readonly EDIT_PROFILE_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.USER);

  public static readonly GET_USER_PROFILE_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.USER);

  public static readonly GET_USER_CONFIGURATION_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.USER_CONFIGURATION);

  public static readonly LOGIN_WITH_APPLE_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.LOGIN_WITH_APPLE);

  public static readonly LOGIN_WITH_FACEBOOK_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.LOGIN_WITH_FACEBOOK);

  public static readonly LOGIN_WITH_GOOGLE_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.LOGIN_WITH_GOOGLE);

  public static readonly LOGIN_ENDPOINT = () => ApiUrls.makeUrl(ApiUrls.LOGIN);

  public static readonly REGISTER_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.REGISTER);

  public static readonly RESET_PASSWORD_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.RESET_PASSWORD);

  /* VERSION */
  public static readonly GET_MINIMUM_APP_VERSION_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.MINIMUM_APP_VERSION);

  /* Match Player */
  public static SEARCH_MATCH_PLAYER_ENDPOINT = () =>
    ApiUrls.makeUrl(ApiUrls.SEARCH_MATCH_PLAYER);

  public static readonly SET_COMPETITIVE_MATCH_ENDPOINT = (matchId: string) =>
    `${ApiUrls.makeUrl(ApiUrls.SET_COMPETITIVE_MATCH)}${matchId}/`;

  public static readonly SET_COMPETITIVE_BOOKING_ENDPOINT = (
    bookingId: string
  ) => `${ApiUrls.makeUrl(ApiUrls.SET_COMPETITIVE_BOOKING)}${bookingId}/`;

  /* INTERNAL API  */
  public static readonly GET_USER_TOKEN_ENDPOINT = (email: string) =>
    `${ApiUrls.makeUrl(ApiUrls.INTERNAL_API)}${ApiUrls.GET_USER_TOKEN}/${email}/`;

  /*
  public static readonly  _ENDPOINT = () => ``;
  */

  /**
   * Generates the URL for the given resource.
   * @param resource the resource to generate the URL for.
   * @returns the URL for the given resource.
   */
  static makeUrl(resource: string): string {
    return `${ApiUrls.BASE_URL}/${resource}/`;
  }
}
